import { SectionBgView } from './SectionBgView.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { SectionView } from './SectionView.ts';
import { uiGameManager } from '../../../shared/scripts/EntryShared.ts';
import { Sprites } from '../ui_game/UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../UIGameSpriteHandler.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export class GeneralButtonView extends SectionView {
    updateAction(action) {
        this.action = action;
    }
    setTip(title, bodyParagraphs) {
        const toolTipText = ()=>({
                title: title,
                body: bodyParagraphs
            });
        uiGameManager.toolTipController.createTip(toolTipText, this);
    }
    setClickAction() {
        if (this.cursor != 'pointer') this.cursor = 'pointer';
        if (!this.interactive) this.interactive = true;
        this.on('click', (event)=>{
            this.action(event);
            AudioManager.play(AudioType.Click);
        });
        this.on('tap', (event)=>{
            this.action(event);
            AudioManager.play(AudioType.Click);
        });
    }
    setHover() {
        this.interactive = true;
        const isDiscordMobile = UIUtilsEjsVariables.isUserOnDiscordMobile;
        const downEvent = isDiscordMobile ? 'pointerdown' : 'mouseover';
        const upEvent = isDiscordMobile ? 'pointerup' : 'mouseout';
        this.on(downEvent, (event)=>{
            this.hoverSize();
        });
        this.on(upEvent, (event)=>{
            this.returnToOriginalPosition();
        });
        if (isDiscordMobile) {
            this.on('pointerupoutside', (event)=>{
                this.returnToOriginalPosition();
            });
        }
    }
    hoverSize() {
        if (this.viewContainer.destroyed) return;
        const growth = 0.05;
        const x = this.viewContainer.x + this.viewContainer.width * growth / 2;
        const y = this.viewContainer.y + this.viewContainer.height * growth / 2;
        this.viewContainer.position.set(x, y);
        this.viewContainer.scale.set(0.95);
    }
    returnToOriginalPosition() {
        if (this.viewContainer.destroyed) return;
        const { x, y } = this.viewContainer.initialPosition;
        this.viewContainer.position.set(x, y);
        this.viewContainer.scale.set(1);
    }
    destroy() {
        this.viewContainer.destroy({
            children: true
        });
    }
    constructor(x, y, w, h, container, removePadding){
        super(x, y, w, h, container, removePadding), this.action = ()=>undefined;
        this.viewContainer = new SectionBgView(0, 0, this.width, this.height, this, true);
        this.viewContainer.drawRoundedBg(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.bg_button), undefined, 0);
        this.setClickAction();
        this.setHover();
    }
}
